import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';

interface EditorFormActionsProps {
  onCancel?: () => void;
  cancelLabel?: string;
  submitLabel?: string;
  submitDisabled?: boolean;
  cancelDisabled?: boolean;
  leftSlot?: ReactNode;
  justifyContent?: 'flex-end' | 'space-between';
}

export default function EditorFormActions({
  onCancel,
  cancelLabel,
  submitLabel,
  submitDisabled,
  cancelDisabled,
  leftSlot,
  justifyContent = 'flex-end',
}: EditorFormActionsProps) {
  const { t } = useTranslation();

  return (
    <DialogActions sx={{ justifyContent, px: 3, pb: 2 }}>
      {justifyContent === 'space-between' ? leftSlot : null}
      <Box sx={{ ml: 'auto' }}>
        {onCancel ? (
          <Button onClick={onCancel} variant="outlined" disabled={cancelDisabled} sx={{ mr: 2 }}>
            {cancelLabel ?? t('base.cancel')}
          </Button>
        ) : null}
        <Button type="submit" variant="contained" color="primary" disabled={submitDisabled}>
          {submitLabel ?? t('form.save')}
        </Button>
      </Box>
    </DialogActions>
  );
}
